<template>
  <div class="ykt-schoolcourse-management">
    <!-- <div class="school-course-name left" v-if="auth.userType==3 || auth.userType==4">
        <router-link :to="{name:'TextbookManagement'}"> 教材 </router-link >>
        <span class="school-course-active">{{courseNameTop}}</span>
    </div>
    <div v-show="newCourse!='true'" class="school-course-name left tea-dark-color" v-else>
      <router-link :to="{name:'OwnSourceList'}" class="tea-dark-color" v-if="isCourse=='school'">本校资源</router-link > 
      <router-link :to="{name:'ThirdpartSourceList'}" class="tea-dark-color" v-if="isCourse=='partner'">外校资源</router-link >>
      <span class="school-course-active">{{courseNameTop}}</span>
      <router-link :to="{name:'OwnSourceList'}" v-if="isCourse=='school'" style="position: fixed;top: 53px;right: 55px;" class="el-button yk-btn-new yk-btn-new-back-s el-button--primary el-button--small">
        <i class="wl-icon-fanhui2"></i>
      </router-link>
      <router-link :to="{name:'ThirdpartSourceList'}" v-if="isCourse=='partner'" style="position: fixed;top: 53px;right: 55px;" class="el-button yk-btn-new yk-btn-new-back-s el-button--primary el-button--small">
        <i class="wl-icon-fanhui2"></i>
      </router-link>
    </div> -->
    <!-- <div v-show="newCourse=='true'" class="school-course-name left tea-dark-color school-course-name-course" style="width:94%">
      <span class="school-course-active">{{courseNameTop}}</span>
      <el-button type="primary" @click="goback" class="gobackBtn-m" icon="wl-icon-fanhui2" style="float:right;"></el-button>
    </div> -->
    <div class="yk-course-statistics-man">
      <div :class="{'management-tea-div':true}">
        <ul :class="{clearfix:true,'management-tea-ul':management}">
          <li v-for="(item,index) of list"
              :key="index"
              :class="{'active':index==icon}"
              @click="handleClick(index,item.name)">{{item.name}}</li>
          <span>
            <el-button type="primary" size="medium" style="float:right;margin:9px 20px 0px 0px;color:#fff;" @click="portalEdit=true">发布到</el-button>
            <el-button type="primary" size="medium" icon="wl-icon-fanhui2" class="btn-primary-medium" style="float:right;margin:9px 20px 0px 0px;color:#fff;" @click="goBack"></el-button>
          </span>
        </ul>
      </div>
    </div>
    <div class="management-bottom management-tea">
      <router-view :isShow="isShow" :IsAll="IsType" :importCourseVisible="importCourseVisible" @offOver="overOff"></router-view>
    </div>
    <el-dialog title="发布到"
             :visible.sync="portalEdit"
             width="550px"
             :append-to-body="true"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="cance">
      <div class="material-form-detail clearfix">
        <el-checkbox-group v-model="checkList">
        <div v-for="(item,index) in portalList"
            :key="index"
            :index="index"
            :item="item"
            style="margin-top:2%;">
            <el-checkbox :label="item.Id" style="margin-left: 0px;position: relative;top: -25px;">&nbsp;</el-checkbox>
            <img :src="item.img"/>
        </div>
        </el-checkbox-group>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click.stop="cance()">取消</el-button>
        <el-button type="primary" @click="sureEdit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  name: 'ShareManagement',
  components: {},
  data() {
    return {
      schoolListPower:["u6kiaa6pk55onu1sbp7twq","hqtpangpuq1i5gzyxh9fiw","lxygap6oi5dhjfhjvoe4kw"],
      checkList:[],
      portalEdit:false,
      portalList:[{
        Id:"fhmooc",
        name:"凤凰慕课",
        img:"https://file.clpp.org.cn/66ykt/ori/u6kiaa6pw7ppy3uehgzjaw/AXyZspJHS6t8ytMh.png"
      },
      // {
      //   Id:"wlykt",
      //   name:"物流云课堂",
      //   img:"https://file.clpp.org.cn/66ykt/ori/3ff6adoqgabnwknhnwyxww/iCKcNyQzADnNDE52.png"
      // },
      {
        Id:"clppx",
        name:"北京中物联物流采购培训中心",
        img:"https://file.clpp.org.cn/66ykt/ori/seiwar2qh5tm31taautdra/Wy4DxkEdmdYZw2PD.png"
      }],
      IsType:false,
      name:"课件",
      list: [
        {
          name: '课件'
        },
        {
          name: '作业'
        },
        {
          name: '题库'
        },
        {
          name: '互动'
        },
        {
          name: '目录'
        },
        {
          name: '辅页'
        }
      ],
      title: [{ name: '本校资源' }, { name: '外校资源' }],
      icon: 5,
      icon02: 0,
      management: true,
      isNew: '',
      aaaa: '',
      whereIsNow: '',
      isCurriculum: true,
      isShow:false,
      importCourseVisible:false,
      isAdd2: '',
      isCourse: '',
      courseNameTop: '',
      schoolCourse: '',
      newCourse: '',
    };
  },
  props: {
    lastCourseId:{
      type: String,
      default: ''
    },
    isImport: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      default: ''
    },
    schoolCourseId: {
      type: String,
      default: ''
    },
    userType: {
      type: [String,Number],
      default: ''
    },
    isAdd: {
      type: String,
      dafault: ''
    },
    show:{
      type:String,
      dafault:''
    }
  },
  created() {
    this.isShcoolOrPartner();
    this.lightTitlt();
    this.getSchoolPortalPower();
  },
  methods: {
    goBack(){
      this.$router.push({
        name: 'teaBookList'
      })
    },
    cance(){
      this.portalEdit=false;
    },
    getSchoolPortalPower(){
      var that=this;
      this.$http.post("/api/XOrg/BookMaterial/getSchoolPortalPower",{
        courseId:that.courseId,
      }).then(function(rst){
        if(rst.code>0){
          that.checkList=rst.PortalPower.split(",");
        }
      })
    },
    sureEdit(){
      var that=this;
      this.$http.post("/api/XOrg/BookMaterial/addIndexShow",{
        index: that.checkList,
        courseId:that.courseId,
      }).then(function(rst){
        if(rst.code>0){
          that.portalEdit=false;
          that.checkList=[];
          that.$message.success(rst.msg);
          that.getSchoolPortalPower();
        }
      })
    },
    overOff(data){
      this.importCourseVisible = data;
    },
    importToCourse() {
      this.IsType=true;
      this.importCourseVisible = true;
    },
    importPartCourse(){
      this.IsType=false;
      this.importCourseVisible = true;
    },
    getShow() {
      this.isShow = !this.isShow;
      console.log(this.isShow);
    },
    goBackTure() {
      if (this.IsForeign) {
        this.$router.push({
          name: 'SharePartnerCourse',
          params: {
            schoolCourseId: this.schoolCourseId,
            IsForeign: this.IsForeign
          }
        });
      }else {
        this.$router.push({
          name: 'ShareManageCourse',
          params: {
            schoolCourseId: this.schoolCourseId
          }
        });
      }
    },
    goBackSharePartnerCourse() {
      this.$router.push({
        name: 'SharePartnerCourse',
        params: {
          schoolCourseId: this.schoolCourseId,
          IsForeign: this.IsForeign
        }
      });
    },
    goback() {
      this.$router.go(-1);
      // this.$router.push({
      //   name: 'ImportCourse',
      //   params: {
      //     courseId: this.lastCourseId
      //   }
      // });
    },
    handleClick(i,name) {
      debugger;
      this.name=name;
      this.icon = i;
      this.$route;
      if (i == 0) {
        this.$router.push({
          name: 'teaShareManagementSource',
          params: {
            schoolCourseId: this.schoolCourseId,
            courseId: this.courseId,
            folderId: '0',
            name: this.courseNameTop,
          }
        });
      } else if (i == 1) {
        this.$router.push({
          name: 'teaShareManagementHomework',
          params: { schoolCourseId: this.schoolCourseId }
        });
      } else if (i == 2) {
        this.$router.push({
          name: 'teaShareManagementQuestion',
          params: {
            schoolCourseId: this.schoolCourseId,
            courseId: this.courseId
          }
        });
      } else if (i == 3) {
        this.$router.push({
          name: 'teaShareManagementinteraction',
          params: {}
        });
      } else if (i == 4) {
        this.$router.push({
          name: 'teaShareManagementCatalogue',
          params: { schoolCourseId: this.schoolCourseId }
        });
      }else if(i == 5){
        this.$router.push({
          name: 'teaShareManagementattached',
          params: {}
        });
      }
    },
    // 判断本校、第三方
    isShcoolOrPartner() {
      this.whereIsNow = localStorage.getItem('address');
      if (this.whereIsNow == 'partner') {
        this.icon02 = 1;
      } else if (this.whereIsNow == 'school') {
        this.icon02 = 0;
      }
    },
    // 页面跳转
    goManagement(i) {
      if (i == 0) {
        localStorage.setItem('menuIndexTea', '0');
        this.$router.push({
          name: 'OwnSourceList'
        });
      } else {
        localStorage.setItem('menuIndexTea', '1');
        this.$router.push({
          name: 'ThirdpartSourceList'
        });
      }
    },
    //判断标题高亮显示
    lightTitlt(){
      let path=this.$route.path;
      if(path.indexOf('ShareManagementSource')!=-1 || path.indexOf('ImportCourse')!=-1){
        this.icon=0;
      }else if(path.indexOf('ShareManagementHomework')!=-1){
        this.icon=1;
      }else if(path.indexOf('ShareManagementQuestion')!=-1){
        this.icon=2;
      }else if(path.indexOf('ShareManagementCatalogue')!=-1){
        this.icon=4;
      }else if(path.indexOf('teaShareManagementattached')!=-1){
        this.icon=5;
      }else{
        this.icon=3;
      }
    }
  },
  mounted() {
    
  }
});
</script>

<style lang="scss" scoped>
.ykt-schoolcourse-management {
  width: 96%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  margin: 40px 2% 0 2%;
  min-height:400px;
  .yk-course-statistics-man {
    .yk-statistics {
      position: relative;
      margin-top: 10px;
      width: 13%;
      height: 79px;
      border-radius: 10px;
      color: #fff;
      i {
        font-size: 50px;
      }
      cursor: pointer;
      .s-type-ceater {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 36px;
        width: 100%;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 0 0 10px 10px;
        text-align: center;
        font-family: SourceHanSansCN-Regular;
        color: #fff;
        line-height: 36px;
      }
      .icon {
        display: block;
        float: left;
        margin: 10px 0px 0 15px;
        font-size: 50px;
      }
      img {
        width: 55px;
        height: 55px;
        margin: 18px 5px 0 20px;
      }
      &.type-one {
        background-color: #c588c5;
      }
      &.type-two {
        background: #7fcbd0;
      }
      &.type-three {
        background: #e49190;
      }
      &.type-four {
        background: #8688d9;
      }
      &.type-five {
        background: #f5b873;
      }
      &.type-six {
        background-color: #71cf7c;
      }
      &.type-seven {
        background-color: #cf719d;
      }
      .s-type-text {
        display: block;
        float: right;
        margin-right: 12%;
        font-size: 20px;
        p.top {
          margin-top: 27px;
          font-size: 16px;
        }
        p {
          text-align: right;
          margin: 0;
        }
        p:last-child {
          margin-top: 8px;
          font-size: 22px;
          font-weight: bolder;
        }
      }
    }
    ul {
      margin: 0;
      padding: 0;
      border-bottom: 1px solid #ccc;
      li {
        list-style: none;
        float: left;
        width: 128px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        color: #999999;
      }
      li.active {
        color: #409eff;
        border-bottom: 2px solid #409eff;
      }
    }
  }
  .school-course-name{
    position: fixed;
    top: 49px;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    width: 100%;
    background-color: #edf2f6;
    left: 64px;
    padding-left: 40px;
    z-index:1000;
    .school-course-active{
      color: #3fa2ff;
    }
    a{
      text-decoration: none;
    }
  }
  .school-course-name-course{
    top: 10px;
    .el-button{
      margin-top:-5px;
      padding: 5px 15px;
      font-size:27px;
    }
  }
  .isManagement-show{
      position:fixed;
      top: 0px;
      left: 64px;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.19);
      width: 100%;
      z-index: 999;
      span{
        color:#fff;
        font-size:18px;
        display: inline-block;
        height: 50px;
        line-height: 52px;
        width: 112px;
        text-align:center;
        cursor: pointer;
      }
      span.active02{
        color:#409eff;
        border-bottom:2px solid  #409eff;
      }
      span:nth-child(2){
        width: 112px;
      }
  }
  .btn-primary-medium{
    float: right;
    padding: 7px 15px;
    font-size: 20px;
  }
}
.dark {
  .management-tea-div {
    .management-tea-ul {
      background-color: #3C4C66;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      li {
        color: #fff;
      }
    }
  }
  .management-tea {
    background-color: #3C4C66;
    .yk-partnerScource .add-card {
      border: 2px dashed #fff;
    }
    .yk-partnerScource .yk-source-container-wrapper .el-card {
      background: #3e5881;
    }
  }
  .isCourse{
    position: fixed;
    top: -5px;
  }
  .button-go-back{
    position: fixed;
    top: 5px;
    right: 30px;
  }
  .yk-course-statistics-man {
    ul {
      border-bottom: 1px solid #596880;
    }
  }
  .ykt-schoolcourse-management {
    background-color: #3C4C66;
    .school-course-name{
         background-color: #374256;
    }
    .tea-dark-color{
      color:#fff;
    }
  }
}
</style>
